var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "site-header" }, [
    _c("div", { staticClass: "site-header__logo" }, [_vm._t("logo")], 2),
    _vm.$mq !== "mobile" && _vm.$mq !== "tablet"
      ? _c(
          "div",
          { staticClass: "site-header__navigation" },
          [_vm._t("primary-navigation")],
          2
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "site-header__utility-nav" },
      [_vm._t("utility-nav")],
      2
    ),
    _vm.$mq === "mobile" || _vm.$mq === "tablet"
      ? _c(
          "div",
          { staticClass: "site-header__mobile-nav" },
          [_vm._t("mobile-navigation")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }